/**
 * Appends a persisted assignment as an option when it would otherwise be filtered out by drift,
 * so edit mode never hides or loses a current value. The option is added only while `isValid`
 * holds (e.g. the assigned vehicle still belongs to the selected carrier) and is de-duplicated
 * against the existing options.
 */
export function withAssignedOption<TEntity, TOption extends { value: string }>(
  options: TOption[],
  assigned: TEntity | null | undefined,
  toOption: (entity: TEntity) => TOption,
  isValid: (entity: TEntity) => boolean = (): boolean => true,
): TOption[] {
  if (!assigned || !isValid(assigned)) return options;
  const option = toOption(assigned);
  if (options.some((existing) => existing.value === option.value)) return options;
  return [...options, option];
}
